import { CreativeTagEvent } from '../../enums';
import { EventEmitter } from '../../types';

export class CreativeEventEmitter implements EventEmitter<CreativeTagEvent> {
  private callbacksMap: {
    [key in CreativeTagEvent]: ((evt?: Event) => void)[];
  } = {
    [CreativeTagEvent.CREATIVE_INIT]: [],
    [CreativeTagEvent.CREATIVE_LOADED]: [],
    [CreativeTagEvent.CREATIVE_REQUESTED]: [],
    [CreativeTagEvent.CREATIVE_LOADING_FAILED]: [],
    [CreativeTagEvent.CREATIVE_ASSET_LOAD]: [],
    [CreativeTagEvent.CREATIVE_DISPLAY]: [],
    [CreativeTagEvent.CREATIVE_VIEW]: [],
    [CreativeTagEvent.CREATIVE_TIMESPENT]: [],
    [CreativeTagEvent.CREATIVE_SHOW]: [],
    [CreativeTagEvent.CREATIVE_CLICKED]: []
  };

  public addEventListener(
    event: CreativeTagEvent,
    callback: (evt?: Event) => void
  ) {
    if (!this.callbacksMap[event]) {
      return;
    }

    this.callbacksMap[event].push(callback);
  }

  public emit(event: CreativeTagEvent, evt?: Event) {
    if (!this.callbacksMap[event]) {
      return;
    }
    this.callbacksMap[event].forEach(callback => callback(evt));
  }
}
